<template>
    <div class="animated fadeIn">
        <Request
                ref="request"
                root="/form-template/builder"
                method="GET"
                :onRequestSuccess="requestSuccess"
                :onRequestError="requestError">
            <slot slot="body">
                <div>
                    <FormBuilder v-if="Core.Validation.isId(dataId)" :formBuilderFieldOptions="{root: { get: '/form-template-field' } }" :formBuilderColumnOptions="{root: { get: '/form-template-column' } }" v-model="dataRows"></FormBuilder>
                </div>
                <div>
                    <div class="text-right">
                        <hr/>
                        <b-button type="button" @click="onSaveStructureClick" variant="success">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
                    </div>
                </div>
            </slot>
        </Request>
    </div>
</template>

<script>
    import Request from '../../components/Request'
    import FormBuilder from '../../components/FormBuilder'
    export default {
        name: 'FormTemplateStructure',
        components: {
            Request,
            FormBuilder
        },
        props: {
            value: {
                type: String | Number,
                default: ''
            }
        },
        watch: {
            value(val) {
                this.dataId = val
            },
            dataId(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataId = this.value
            this.$refs.request.clearArgs()
            this.$refs.request.setMethod('GET')
            this.$refs.request.addArg('formTemplateId', this.dataId)
            this.$refs.request.request()
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataId: '',
                dataRows: []
            }
        },
        methods: {
            requestSuccess(data) {
                if (data.rows !== undefined) {
                    this.dataRows = data.rows
                }

                this.$nextTick(function () {
                    for(let row in this.dataRows) {
                        row = this.dataRows[row]
                        for(let col in row.cols) {
                            col = row.cols[col]
                            for(let field in col.fields) {
                                field = col.fields[field]
                                if (field.type === Core.Value.typeSpreadsheet) {
                                    let id = field.id
                                    let defaultValue = field.defaultValue
                                    field.value = defaultValue
                                    id = 'hotTable' + id
                                    let container = document.getElementById(id)
                                    if (container.hotInstance === undefined) {
                                        Core.Spreadsheet.init(container, field)
                                    }
                                }
                            }
                        }
                    }
                })


            },
            requestError(data) {
            },
            onSaveStructureClick() {
                for(let rowIndex in this.dataRows) {
                    let row = this.dataRows[rowIndex]
                    for(let colIndex in row.cols) {
                        let col = row.cols[colIndex]
                        for(let fieldIndex in col.fields) {
                            let field = col.fields[fieldIndex]
                            let id = field.id
                            id = 'hotTable' + id
                            if (field.type === Core.Value.typeSpreadsheet) {
                                let container = document.getElementById(id)
                                if (container.hotInstance) {
                                    this.dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue = Core.Spreadsheet.extractData(container)
                                    this.dataRows[rowIndex].cols[colIndex].fields[fieldIndex].data.spreadsheet.settings = Core.Spreadsheet.extractSettings(container)
                                }
                            }

                            /*
                            if (this.$refs.request !== undefined &&
                                this.$refs.request.$children !== undefined &&
                                this.$refs.request.$children[1] !== undefined &&
                                this.$refs.request.$children[1].$refs['hotTable' + id] !== undefined &&
                                this.$refs.request.$children[1].$refs['hotTable' + id][0] !== undefined &&
                                this.$refs.request.$children[1].$refs['hotTable' + id][0].hotInstance !== undefined) {
                                let hotTable = this.$refs.request.$children[1].$refs['hotTable' + id][0]
                                this.dataRows[rowIndex].cols[colIndex].fields[fieldIndex].defaultValue = Core.Spreadsheet.extractData(hotTable)
                                this.dataRows[rowIndex].cols[colIndex].fields[fieldIndex].data.spreadsheet.settings = Core.Spreadsheet.extractSettings(hotTable)
                            }*/
                        }
                    }
                }

                this.$refs.request.clearArgs()
                this.$refs.request.setMethod('PUT')
                this.$refs.request.addArg('formTemplateId', this.dataId)
                this.$refs.request.addArg('rows', JSON.stringify(this.dataRows))
                this.$refs.request.request()
            }
        }
    }
</script>
